module.exports = __webpack_public_path__ + "static/features-c0f0ad1be8640b8f38d14c89a305a5e5.svg";